import {
  setInventoryRequest,
  unsetInventoryRequest,
  clearInventoryRequest,
} from "../actions/inventoryRequestsAction";

import { IRIMSActions } from "../../types";

const initialState: any = {
  items: JSON.parse(localStorage.getItem('inventory-request') || '{}'),
};

export default function(state: any = initialState, action: any) {
  switch (action.type) {
    case IRIMSActions.SetInventoryRequest:
      return setInventoryRequest(state, action);

    case IRIMSActions.UnsetInventoryRequest:
      return unsetInventoryRequest(state, action);

    case IRIMSActions.ClearInventoryRequest:
      return clearInventoryRequest(state, action);

    default:
      return state;
    }
}